export default __webpack_public_path__ + "static/logo_fml-06116eb89d422b3a3a2fb5563380ae83.webp";